<script>
    import { ICONS } from './../../../js/icons.js';
    import { onMount } from 'svelte';

    export let onCategoryChange;
    export let active_view;

    const MENU = [
        {id: 'games', label: 'Juegos', iconHtmlKey: 'games'},
        {id: 'brands', label: 'Marcas', iconClass: 'bi bi-people'},
        {id: 'clients', label: 'Clientes', iconHtmlKey: 'persons'},
        {id: 'users', label: 'Jugadores', iconHtmlKey: 'user'},
        {id: 'admins', label: 'Administradores', iconHtmlKey: 'user'},
        {id: 'transactions', label: 'Transacciones', iconHtmlKey: 'trx'},
        {id: 'direct_trx', label: 'Transacciones Manuales', iconHtmlKey: 'trx'},
        {id: 'reports', label: 'Reportería', iconHtmlKey: 'graf'},
        {id: 'users_lite', label: 'Usuarios (lite)', iconHtmlKey: 'user'},
        {id: 'transactions_lite', label: 'Transacciones (lite)', iconHtmlKey: 'trx'},
        {id: 'bonus-management', label: 'Gestor bonos', iconHtmlKey: 'database'},
    ];
    let role = null;
    let allowed  = null;
    let ready    = false;

    const canSee = (id) => allowed === null ? true : allowed.includes(id);
    const isDisabled = () => false;
    onMount(async () => {
        let data = {};
        try { data = JSON.parse(sessionStorage.getItem('user') || '{}'); } catch {}
        const rawRole = (data && (data.role));
        role = Number.isFinite(Number(rawRole)) ? Number(rawRole) : null;

        if (role === -1) {
            allowed = null;
        } else if (role === 10) {
            const userId = data?.id;
            if (userId) {
                try {
                    const configModule = (await import('../../../config.js')).default;
                    const conf = configModule.getConfiguration();
                    const token = sessionStorage.getItem('token');
                    const res = await fetch(`${conf.API}/credentials?prefix=bo_views.${userId}`, {
                        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
                    });
                    const map = await res.json();
                    const raw = map[`bo_views.${userId}`];
                    if (raw && raw.trim()) {
                        const views = raw.split(',').map(v => v.trim()).filter(Boolean);
                        if (views.length > 0) {
                            allowed = views;
                        } else {
                            allowed = null;
                        }
                    } else {
                        allowed = null;
                    }

                    try {
                        const cliRes = await fetch(`${conf.API}/credentials?prefix=bo_clients.${userId}`, {
                            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
                        });
                        const cliMap = await cliRes.json();
                        const cliRaw = cliMap[`bo_clients.${userId}`];
                        if (cliRaw && cliRaw.trim()) {
                            const u = JSON.parse(sessionStorage.getItem('user') || '{}');
                            u.bo_client_codes = cliRaw.split(',').map(v => v.trim()).filter(Boolean);
                            sessionStorage.setItem('user', JSON.stringify(u));
                        }
                    } catch {}
                } catch (e) {
                    console.error('Error fetching bo_views', e);
                    allowed = [];
                }
            } else {
                allowed = null;
            }
        } else {
            allowed = [];
        }
        ready = true;
    });
    function handleClick(id) {
        if (isDisabled(id)) return;
        onCategoryChange(id);
    }
</script>

{#if ready}
    <div class="btn-menu-central">
        {#each MENU as item}
            {#if canSee(item.id)}
                <button
                        class="btn-op {active_view === item.id ? 'u-category-select' : ''} {isDisabled(item.id) ? 'is-disabled' : ''}"
                        disabled={isDisabled(item.id)}
                        aria-disabled={isDisabled(item.id)}
                        on:click={() => handleClick(item.id)}
                >
                    {#if item.iconHtmlKey}
                        {@html ICONS[item.iconHtmlKey]}
                    {:else if item.iconClass}
                        <i class={item.iconClass}></i>
                    {/if}
                    <span>{item.label}</span>
                </button>
            {/if}
        {/each}
    </div>
{:else}
    <div style="min-height:48px"></div>
{/if}

<style>
    .btn-menu-central {
        display: flex;
        justify-content: center;
        gap: 0.8rem;
        flex-direction: row;
        padding: 0.5rem;
    }
    .btn-op {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0.3rem;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        text-decoration: none;
        width: 12rem;
        text-align: center;
        color: #fff;
        border-radius: 0.4rem;
        background-color: #FF0090;
        border: none;
    }
    .btn-op:hover { background-color: #e100ff; }
    .bi { font-size: 1.5em; margin-bottom: 10px; }
    :global(.btn-op.u-category-select){
        background-color: #fff !important;
        border: 2px solid #FF0090 !important;
        color: #FF0090 !important;
        border-radius: 0.4rem;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.2s;
        box-shadow: 0 4px 12px rgba(255, 0, 144, 0.25) !important;
        transform: translateY(-2px);
    }
    :global(.btn-op.u-category-select:hover) {
        background-color: #fff0f6 !important;
        color: #FF0090 !important;
    }
    .btn-op.is-disabled,
    .btn-op[disabled] {
        opacity: 0.6;
        cursor: not-allowed;
        filter: grayscale(0.15);
    }
    .btn-op.is-disabled:hover { background-color: #FF0090; }
    @media (max-width: 600px) {
        .btn-menu-central {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
        }
    }
</style>
